export default "__VITE_ASSET__DJ5s6LCp__"